<template>
    <div class="dashboard-table-card-container ">
      <le-card width="100%" style="padding-bottom:20px" >
        <template>
          <div class="container">
            <div class="card-title" style="padding-top: 20px;">公会管理</div>
            <le-button txt="新增" class="le-button" @btnClick="visible=true" v-if="isAdd"  />
            <div class="table-box">
                <a-table 
                :columns="columns" 
                :data-source="dataSource"
                :loading="loading"
                :pagination="false"
                @change="handleTableChange"
                size="middle" >
                  <span slot="action" style="display: flex;justify-content:space-between;width: 100px;" slot-scope="row">
                    <le-button txt="编辑" width="40px" height="30px" fontSize="14px" @btnClick="clickEdit(row)" v-if="isEdit" />
                    <a-popconfirm title="确定删除吗？" ok-text="确定" cancel-text="取消"   @confirm="toDelete(row)"  v-if="isDelete" >
                      <le-button background="linear-gradient(-10deg, #FD8A8F, #FA6A9D)" txt="删除" width="40px" height="30px" fontSize="14px"/>
                    </a-popconfirm>
                  </span>
              </a-table>
            </div>
          </div>
        </template>
      </le-card>
      <popAdd v-if="visible" :visible="visible"  @handleOk="handleOk"  @handleCancel="visible=false"  />
      <popEdit v-if="visibleEdit" :visible="visibleEdit"  @handleOk="handleOk"  @handleCancel="visibleEdit=false" :row="editRow"  />
    </div>
</template>

<script>

import columns from './columns'
import popEdit from './popEdit'
import popAdd from './popAdd'
import tool from '@/utils/tool'
import {MixinList} from './mixin';
export default {
  components: {
    popEdit,
    popAdd
  },
  data() {
    return {
      columns,
      dataUrl:'v2/guildManage/all',
      delUrl:'v2/guildManage/del',
      visible: false,
      visibleEdit: false,
      uid:'',
      editRow:{},
      isAdd: false,
      isEdit: false,
      isDelete: false
    };
  },
  computed: {
  },
  mixins:[MixinList],
  mounted(){
    let btn=window.localStorage.getItem('whiteBtns')
    if(btn){
      let btns=btn.split(',');
      if(btns.includes('auth-guild-add')){
        this.isAdd = true;
      }

      if(btns.includes('auth-guild-edit')){
        this.isEdit = true;
      }

      if(btns.includes('auth-guild-delete')){
        this.isDelete = true;
      }
    }



  },
  methods: {
    clickEdit(row){
      this.editRow=row
      this.visibleEdit = true;
    },
    handleOk(){
      this.visible=false;
      this.visibleEdit = false;
      this.getData()
    }
  }
};
</script>

<style lang="less" scoped>
.dashboard-table-card-container {
.container{
  position: relative;
  .title{
    padding-top: 20px;
    margin-left: 30px;
    font-size: 30px;
    font-weight: bold;
    color: #333333;
    display: flex;
    align-items: flex-end;
    .num-box{
      font-size: 18px;
      margin-left: 11px;
      line-height: 32px;
    }
  }
  .le-button{
    position: absolute;
    top: 30px;
    right: 30px;
  }

  .table-box{
    margin: 40px 30px;
  }
}
}

.login{
  cursor: pointer;
  &:hover{
    color: #008DF0;
  }
}

.name-box{
  display: flex;
  .avatar{
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin-right: 10px;
    background-color: #333333;
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    img{
    width: 40px;
    height: 40px;
    border-radius: 50%;
    }
  }
}

@media screen and(max-width:750px) {
 .dashboard-table-card-container {
.container{
  .title{
    padding-top: 10px;
    margin-left: 20px;
    font-size: 20px;
    .num-box{
      font-size: 12px;
      margin-left: 5px;
      line-height: 22px;
    }
  }
  .le-button{
    position: absolute;
    top: 10px;
    right: 20px;
    width: 50px!important;
  }

  .table-box{
    margin: 20px;
    overflow-x:scroll ;
  }
}
}
}

</style>
